import { useCallback } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { DsTabNav, type DsTab } from '@/modules/internal-v2/ds';
import './business-partners.css';

/** Page-level tabs of the Business Partners area. */
const TABS: DsTab[] = [
  { id: 'partners', label: 'Geschäftspartner' },
  { id: 'verteiler', label: 'Verteiler' },
];

/**
 * Shell for the Business Partners area: a page-level tab nav over an
 * `<Outlet>`. The "Geschäftspartner" tab renders the {@link BpBrowser}
 * master/detail; the "Verteiler" tab renders the standalone contact-list
 * manager.
 */
export function BusinessPartnersPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const activeTab = pathname.includes('/verteiler') ? 'verteiler' : 'partners';

  const handleTabChange = useCallback(
    (id: string) => {
      navigate(
        id === 'verteiler'
          ? '/i/business-partners/verteiler'
          : '/i/business-partners',
      );
    },
    [navigate],
  );

  return (
    <div className="bp-main">
      <DsTabNav
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      <Outlet />
    </div>
  );
}
